import * as React from 'react';
import { Button, Dropdown, Modal, ModalBody, ModalFooter, ModalTitle, TextField, } from '@symphony-ui/uitoolkit-components';
import { sendError } from 'utils/messageUtils';
import Party from '../../models/Party';
import FindSourceButton from './FindSourceButton';
import ApiServerRequest from 'models/ApiServerRequest';
import DownloadContext from 'contexts/DownloadContext';
const PartyUnknowns = ({ nameOptions, parentNode, partyOptions, saveNameCallback, buttonLoading, onClose }) => {
    const { apiFetchJson } = React.useContext(DownloadContext);
    const [partyId, setPartyId] = React.useState();
    const [name, setName] = React.useState();
    const [newName, setNewName] = React.useState('');
    const buttonRef = React.useRef(null);
    const onChangeName = React.useCallback((event) => {
        setName(event.target.value.value);
        setNewName('');
        setPartyId(undefined);
    }, []);
    const onChangeInput = React.useCallback((event) => {
        setNewName(event.target.value);
    }, []);
    const onChangeParty = React.useCallback((event) => {
        console.log("Party changed to: %o", event);
        setPartyId(event.target.value?.value);
    }, []);
    const saveNameAdd = React.useCallback(() => {
        if (name !== undefined && partyId !== undefined) {
            const formData = new FormData();
            formData.append('name', name);
            formData.append('partyId', partyId);
            const requestInit = { body: formData, method: 'PATCH' };
            const request = new ApiServerRequest('/syndicate/parties/add-name', requestInit);
            (async () => {
                try {
                    const body = await apiFetchJson(request);
                    saveNameCallback(name, new Party(body));
                    setPartyId(undefined);
                    setNewName('');
                }
                catch (error) {
                    sendError("Unable to save unknown parties", error);
                }
            })();
        }
    }, [apiFetchJson, name, partyId, saveNameCallback]);
    const saveNameNew = React.useCallback(() => {
        if (name !== undefined) {
            const newParty = new Party({ name: newName !== '' ? newName : name, names: [name] });
            const requestInit = { body: JSON.stringify(newParty), headers: { 'Content-Type': 'application/json' }, method: 'POST' };
            const request = new ApiServerRequest('/syndicate/parties', requestInit);
            (async () => {
                try {
                    const body = await apiFetchJson(request);
                    setPartyId(undefined);
                    setName('value' in nameOptions[0] ? nameOptions[0].value : undefined);
                    setNewName('');
                    saveNameCallback(name, new Party(body));
                }
                catch (error) {
                    sendError("Unable to save unknown parties", error);
                }
            })();
        }
    }, [apiFetchJson, name, nameOptions, newName, saveNameCallback]);
    const onClearParty = React.useCallback(() => {
        setPartyId(undefined);
    }, []);
    const disabledButton = React.useMemo(() => (name === undefined), [name]);
    const disabledNewName = React.useMemo(() => (partyId !== undefined), [partyId]);
    const disabledParty = React.useMemo(() => (newName !== ''), [newName]);
    const ddvalue = partyOptions.find(o => 'value' in o && o.value === partyId);
    return (React.createElement(Modal, { className: 'cmo-dropdown-absolute', closeButton: true, onClose: onClose, parentNode: parentNode, show: true, size: 'medium' },
        React.createElement(ModalTitle, null, "Allocate Party"),
        React.createElement(ModalBody, null,
            React.createElement(Dropdown, { label: "Name to Allocate", name: "parties", onChange: onChangeName, options: nameOptions, value: nameOptions.find(o => 'value' in o && o.value === name) }),
            React.createElement(Dropdown, { isDisabled: disabledParty, isInputClearable: true, label: "Existing Party", name: "names", onChange: onChangeParty, onClear: onClearParty, options: partyOptions, value: ddvalue }),
            React.createElement(TextField, { disabled: disabledNewName, label: "New Name to Save", onChange: onChangeInput, value: newName || '' })),
        React.createElement(ModalFooter, null,
            React.createElement("div", { className: "form-buttons", ref: buttonRef },
                partyId !== undefined ?
                    React.createElement(Button, { disabled: disabledButton, loading: buttonLoading, onClick: saveNameAdd }, "ADD TO EXISTING")
                    :
                        React.createElement(Button, { disabled: disabledButton, loading: buttonLoading, onClick: saveNameNew }, newName !== '' ? 'SAVE AS NEW' : 'SAVE AS NEW UNDER OWN NAME'),
                React.createElement(FindSourceButton, { name: name })))));
};
export default PartyUnknowns;
